import React from "react";
import { Box } from "@chakra-ui/react";
import { useAppData } from "../store/dataStore";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import ValueProposition from "../components/ValueProposition";
import TrackOverview from "../components/TrackOverview";
import CTAHighlight from "../components/CTAHighlight";
import TestimonialsPreview from "../components/TestimonialsPreview";
import { Helmet } from 'react-helmet-async';
import {  FaShieldAlt,  FaBriefcase,  FaUsers} from 'react-icons/fa';
import {
  coreMessaging,
  personaMessaging,
  componentMessaging,
} from "../data/messaging";
import { useAffiliateCode } from '../hooks/useAffiliateCode';

const Home = () => {

  const { appData } = useAppData();

  // Initialize affiliate code tracking
  useAffiliateCode('home_visit');
  const { course1, course2 } = appData;

  // --- HERO SECTION ---
  const heroData = {
    badge: "🚀 From confusion to clarity",
    title: "Become the AI Engineer companies hire",
    description:
      "Build real apps with structured guidance, review gates, and a portfolio that gets attention.",

    ctaPrimary: {
      label: "Check if this program is right for me",
      link: "/assessment",
    },

    ctaSecondary: {
      label: coreMessaging.ctaFlow.curriculum,
      link: "/beginner-track",
    },

    trustElements: coreMessaging.trustElements, // must be: [{ icon, text }]

    // Optional stats for the bottom part of Hero
    stats: [
      { icon: FaUsers, value: "1:1", label: "Mentor Support" },
      { icon: FaBriefcase, value: "180 Days", label: "Career Target" },
      { icon: FaShieldAlt, value: "15-Day Trial", label: "Full Refund" }
    ],
  };

  // --- VALUE PROPOSITION ---
  const valuePropositionData = {
    title: componentMessaging.valueProposition.heading,
    subtitle: componentMessaging.valueProposition.subtitle,
    values: componentMessaging.valueProposition.points.map((point, i) => ({
      id: i,
      title: point.title,
      description: point.description,
    })),
  };

  // --- TRACKS OVERVIEW ---
  const trackOverviewData = {
    title: "Choose Your Learning Path",
    subtitle:
      "Whether you're starting fresh or accelerating your career, Build real-world GenAI deployment",
    tracks: [
      {
        label: "Most Popular",
        title: "Beginner Track",
        duration: coreMessaging.outcomeStats.duration,
        format:
          "Live sessions (Mon/Wed/Fri) + Doubt resolution (Sat) + Hands-on Projects",
        bestFor: personaMessaging.beginner.title,
        outcomes: personaMessaging.beginner.outcomes,
        price: course1?.price || "₹59,994",
        cta: {
          label: coreMessaging.ctaFlow.curriculum,
          link: "/beginner-track",
        },
      },
      {
        label: "Fast Track",
        title: "Experienced Track",
        duration: "8 Weeks",
        format:
          "Intensive weekend sessions + advanced GenAI projects + mentorship",
        bestFor: personaMessaging.professional.title,
        outcomes: personaMessaging.professional.outcomes,
        price: course2?.price || "₹29,998",
        cta: {
          label: coreMessaging.ctaFlow.curriculum,
          link: "/experienced-track",
        },
      },
    ],
  };

  return (
    <>
      <Helmet>
        <title>GenAI Training | Become a Certified Full Stack AI Developer</title>
        <meta name="description" content="Launch your GenAI career with Ojasa Mirai’s mentor-led training. Build 10+ real-world AI projects, get career support, and become a certified Full Stack AI Developer in 24 weeks." />
      </Helmet>

      <Box>
        <Navbar />

        <Hero data={heroData} />

        <ValueProposition data={valuePropositionData} />

        {/* Mid-Page Conversion CTA */}
        <CTAHighlight />

        {/* Learning Path Overview */}
        <TrackOverview data={trackOverviewData} />

        <TestimonialsPreview
          testimonials={componentMessaging.testimonials}
          title="Success Stories from Our Learners"
        />

        <CTAHighlight />

        <Footer />
      </Box>
    </>

  );
};

export default Home;
